<template>
  <Can action="store" subject="billing">
    <div data-component-group="billing-dialog" data-component="add-new">
      <dialog-add
        icon="credit_card"
        :title="$t('create_dialog')"
        is-fullscreen
        :is-on="true"
        :on-close="onCancel"
      >
        <template v-slot:content>
          <forms-billing-add-new
            :billing-item="{}"
            class="elevation-1"
            :is-loading="isAddingAccount"
            :is-on="true"
            :on-cancel="onCancel"
            :on-submit="createAccount"
          />
        </template>
      </dialog-add>
    </div>
  </Can>
</template>

<script>
  export default {
    data() {
      return {
        isAddingAccount: false,
      };
    },
    methods: {
      onCancel() {
        this.$router.push({ name: 'billing' });
      },
      createAccount(item) {
        this.isAddingAccount = true;

        return this.$store
          .dispatch('billing/create', item)
          .then(() => {
            this.$router.push({ name: 'billing', query: { status: 'success' } });
          })
          .catch(() => {
            return Promise.reject();
          })
          .finally(() => {
            this.isAddingAccount = false;
          });
      },
    },
  };
</script>
